import { useEffect } from "react";
import { PageHeader } from "../components/lendx/PageHeader";
import { Reveal } from "../components/lendx/Reveal";
import { ServiceCard } from "../components/lendx/ServiceCard";
import { CTABanner } from "../components/lendx/CTABanner";
import { SERVICES } from "../lib/data";
import { applySEO } from "../lib/scroll";

const CONFIG = {
  business: {
    overline: "Business Finance",
    title: "Capital That Moves at the Speed of Business",
    sub: "Working capital, expansion funding, project finance, and corporate structures — advisory-led financing for businesses at every stage.",
    seoTitle: "Business Finance | LendX — Business Loans, Working Capital, Corporate Finance",
    seoDesc: "Business finance solutions from LendX: Business Loans, Working Capital Finance, Construction Finance and Corporate Finance structured around your business.",
    testId: "business-finance",
  },
  property: {
    overline: "Property Finance",
    title: "Make Your Property Work for Your Ambitions",
    sub: "From buying your first home to unlocking the value of commercial assets — structured property financing with expert guidance.",
    seoTitle: "Property Finance | LendX — Home Loan, LAP, Commercial Property, LRD",
    seoDesc: "Property finance solutions from LendX: Home Loans, Loan Against Property, Commercial Property Finance and Lease Rental Discounting.",
    testId: "property-finance",
  },
};

export default function CategoryPage({ category }) {
  const cfg = CONFIG[category];
  const services = SERVICES.filter((s) => s.category === category);

  useEffect(() => {
    applySEO(cfg.seoTitle, cfg.seoDesc);
  }, [cfg]);

  return (
    <main data-testid={`${cfg.testId}-page`}>
      <PageHeader overline={cfg.overline} title={cfg.title} sub={cfg.sub} testId={cfg.testId} />
      <section className="bg-white py-20 md:py-28">
        <div className="mx-auto grid max-w-7xl gap-4 px-5 md:grid-cols-2 md:px-8">
          {services.map((s, i) => (
            <Reveal key={s.slug} delay={(i % 2) * 0.08} y={30} className="h-full">
              <ServiceCard service={s} />
            </Reveal>
          ))}
        </div>
      </section>
      <CTABanner />
    </main>
  );
}
